const resolveDeployer = () => {
  const raw = (ipDeployer || "").trim();
  try {
    const u = new URL(raw, window.location.origin);
    if (window.location.protocol === "https:" && u.protocol === "http:") {
      u.protocol = "https:";
    }
    return u.toString().replace(/\/+$/, "");
  } catch {
    return raw.replace(/^http:/, "https:").replace(/\/+$/, "");
  }
};
const agentBase = (id: string) => `${resolveDeployer()}/agent/${id}/proxy`;
import React, { useEffect, useState, useRef } from "react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import DeploymentDialog from "./DeploymentDialog";
import EmailSender from "./EmailSender";
import LogsViewer from "./LogsViewer";
import SettingsDialog from "./SettingsDialog";
import { baseCode } from "./baseCode";
import { emailCode } from "./emailCode"
import { useToast } from "@/components/ui/use-toast";
import html2pdf from "html2pdf.js";
import {
  Bot,
  LogOut,
  Plus,
  Play,
  Square,
  RotateCcw,
  Trash2,
  FileText,
  Settings,
  Activity,
  Mail,
  FileSpreadsheet,
  Bell,
  Loader2,
  BookOpen,
  CreditCard,
  MoreHorizontal,
  X,
  ChevronRight,
  HeadsetIcon,
  MessageCircle,
  ShieldX
} from "lucide-react";
import { decodeWithBase64, encodeWithBase64 } from '@/Services/encodedecode';
import axios from "axios";
import { FSServerID, FSServerIP, LLServerID, LLServerIP, TemplateId, TemplateName, ipDeployer } from "@/Services/Server";
import { useNavigate } from "react-router-dom";
import { UserMenu } from "./UserComponent";
import { addingForumAdminsExternally, paymentInformation, paymentOrder, paymentVerification, SendingBridgeUpdate, userSubscriptionDetails } from "@/Services/Service";
import { toast as toast1 } from "sonner";
import UpgradePage from "@/pages/Upgrade";
import { LanguageStore } from "@/Services/LanguageStore";
import { BridgeLanguage } from "@/Services/Language";
import { v4 as uuidv4 } from 'uuid';

interface DashboardProps {
  onLogout: () => void;
}

interface Deployment {
  id: string;
  name: string;
  status: 'running' | 'stopped' | 'error' | 'deploying';
  createdAt: string;
  emailsSent: number;
  sheetsUrl: string;
  externalIp?: string;
  authStatus?: 'unknown' | 'authenticated' | 'needs_auth' | 'authenticating' | 'warming_up' | 'error';
  authError?: string | null;
  groupEmail?: string;
}

// — Email deployment payload shape used by EmailSender and handler —
type EmailDeployment = { name: string; sheetsUrl: string; subject: string; body: string, emailLimit: string };

// — Simple Sheets URL validator (defense-in-depth) —
const SHEETS_RE = /^https?:\/\/docs\.google\.com\/spreadsheets\/d\/[A-Za-z0-9-_]+/;

// --- OAuth live status helpers (no-refresh auth completion) ---
const AUTH_POLL_MS = 150000;
const WARMUP_POLL_MS = 3000;
const WARMUP_MAX_MS = 3 * 60 * 1000; // 3 minutes

type IntervalHandle = number | ReturnType<typeof setInterval>;

const DashboardComponent = ({ onLogout }: DashboardProps) => {
  const { toast } = useToast();
  const authPollers = useRef<Record<string, IntervalHandle>>({});
  const [deployments, setDeployments] = useState<Deployment[]>([]);
  const [isAgentDeploying, setIsAgentDeploying] = useState(false);
  const navigate = useNavigate();
  const invoiceRef = useRef();
  // Route guard: if user navigates directly to /dashboard without a valid userProfile, send them to /emailtracker
  useEffect(() => {
    try {
      const raw = localStorage.getItem('userProfile');
      if (!raw) {
        navigate('/emailtracker', { replace: true });
        return;
      }
      const parsed = JSON.parse(decodeWithBase64(raw));
      if (!parsed?.SessionID || !parsed?.MACAddress) {
        navigate('/emailtracker', { replace: true });
      }
      checkSubscription();
      // FetchingPaymentInfo()
    } catch {
      // Any parsing or storage error → go to emailtracker
      navigate('/emailtracker', { replace: true });
    }
  }, [navigate]);
  const [showDeployDialog, setShowDeployDialog] = useState(false);
  const [showEmailDialog, setShowEmailDialog] = useState(false);
  const [showLogsFor, setShowLogsFor] = useState<string | null>(null);
  const [showSettingsFor, setShowSettingsFor] = useState<string | null>(null);
  const [showRemindFor, setShowRemindFor] = useState<string | null>(null);
  const DEFAULT_REMINDER_SUBJECT = 'Gentle reminder – awaiting your update';
  const DEFAULT_REMINDER_BODY = "Hi there,\n\nWe haven't received a 'completed' update from you yet. Please reply to the previous email with your current status at your earliest convenience.\n\nThanks!";
  const [reminderSubject, setReminderSubject] = useState<string>(DEFAULT_REMINDER_SUBJECT);
  const [reminderBody, setReminderBody] = useState<string>(DEFAULT_REMINDER_BODY);
  const [sendingReminders, setSendingReminders] = useState<boolean>(false);
  const [showGroupFor, setShowGroupFor] = useState<string | null>(null);
  const [groupEmailInput, setGroupEmailInput] = useState<string>("");
  const [savingGroup, setSavingGroup] = useState<boolean>(false);
  const [showDocs, setShowDocs] = useState<boolean>(false);
  const [showUpgrade, setShowUpgrade] = useState<boolean>(false);
  const [selectcost, setSelectedCost] = useState(null);
  const [invoicedisplay, setInvoiceDisplay] = useState(false);
  const [otherinvoicedisplay, setOtherInvoiceDisplay] = useState(false);
  const [customerName, setCustomerName] = useState("");
  const [customerplace, setCustomerplace] = useState("");
  const [taxableamount, setTaxabelAmount] = useState(null);
  const [cgstamount, setCGSTAmount] = useState(null);
  const [sgstamount, setSGSTAmount] = useState(null);
  const [totalammount, setTotalAmount] = useState(null);
  const [invoicenumber, setInvoicenumber] = useState(null);
  const [ammount, setAmmount] = useState(0);
  const [showHelpDesk, setShowHelpDesk] = useState<boolean>(false);
  const [mobileActionsOpen, setMobileActionsOpen] = useState<boolean>(false);
  const [isUserEmployee, setUserEmployee] = useState<boolean>(false);
  const [showBlockedDomains, setShowBlockedDomains] = useState(false);
  const [blockedDomainList, setBlockedDomainList] = useState<string[]>([]);
  const [existingBlockedDomain, setExistingBlockedDomain] = useState<string[]>([]);
  const [blockedDomain, setBlockedDomain] = useState("");
  const [blockedFor, setBlockedFor] = useState("");
  const [addingBlockedDomains, setAddingBlockedDomains] = useState(false);
  const [isDeploymentAunthenticated, setDeploymentAunthenticated] = useState([]);
  const [showDailyEmailLimit, setShowDailyEmailLimit] = useState(false);
  const [dailyEmailLimit, setDailyEmailLimit] = useState(0);
  const [minEmailLimit, setMinEmailLimit] = useState(1);
  const [maxEmailLimit, setMaxEmailLimit] = useState(2000);
  const [currentEmailLimit, setCurrentEmailLimit] = useState(450);
  const [updatingEmailDailyLimit, setUpdatingEmailLimit] = useState(false);
  const [selectedDeployment, setSelectedDeployment] = useState("");

  const LanguageString = (number: any) => {
    let LangData = LanguageStore.allLanguages;
    if (Object.keys(LangData).length === 0) {
      let localLang = localStorage.getItem('BridgeLanguageStrings');
      if (localLang) {
        LangData = JSON.parse(decodeWithBase64(localLang));
      }
    }
    if (LangData && LangData[number]) {
      return LangData[number];
    }
    else {
      return BridgeLanguage(number);
    }
  }

  const clearAllClientData = async () => {
    try { localStorage.clear(); } catch { }
    try { sessionStorage.clear(); } catch { }
    // Clear caches (if supported)
    try {
      if ('caches' in window) {
        const names = await caches.keys();
        await Promise.all(names.map(n => caches.delete(n)));
      }
    } catch { }
    // Best-effort clear IndexedDB (if supported by the browser)
    try {
      const anyIDB: any = indexedDB as any;
      if (anyIDB && typeof anyIDB.databases === 'function') {
        const dbs = await anyIDB.databases();
        if (Array.isArray(dbs)) {
          await Promise.all(
            dbs.map((db: any) => db?.name ? new Promise<void>((resolve) => {
              const req = indexedDB.deleteDatabase(db.name);
              req.onsuccess = req.onerror = req.onblocked = () => resolve();
            }) : Promise.resolve())
          );
        }
      }
    } catch { }

    // Reset UI state
    setDeployments([]);
    setShowDeployDialog(false);
    setShowEmailDialog(false);
    setShowLogsFor(null);
    setShowSettingsFor(null);
    setShowRemindFor(null);
    setGroupEmailInput("");
    setSavingGroup(false);
    setSendingReminders(false);
    setReminderSubject(DEFAULT_REMINDER_SUBJECT);
    setReminderBody(DEFAULT_REMINDER_BODY);
  };

  const checkSubscription = async () => {
    try {
      const subscriptionData = await userSubscriptionDetails("Subscription");
      const userType = subscriptionData['ErrorMessage']['UserType'];
      if (userType === 'Free') {
        const isNewLogin = sessionStorage.getItem("IsNewlogin");
        if (isNewLogin === "true") {
          setShowUpgrade(true);
          sessionStorage.removeItem("IsNewlogin");
        }
      }
      else if (userType === 'Employee') {
        setUserEmployee(true);
      }
      // else {
      //   let isActive = subscriptionData['ErrorMessage']['Active'];
      //   if (isActive) setUserEmployee(true);
      // }
    } catch (error) {
      console.error('Subscription check error:', error);
    }
  }
  // Start polling an agent's /auth/status until it becomes "authenticated"
  const beginAuthPolling = (depId: string, baseUrl: string) => {
    // Clear any existing poller for this deployment
    const existing = authPollers.current[depId];
    return
    if (existing) {
      clearInterval(existing as any);
      delete authPollers.current[depId];
    }
    const iv = setInterval(async () => {
      try {
        const res = await fetch(`${baseUrl}/auth/status`, { credentials: "include" });
        const data = await res.json().catch(() => ({}));
        if (data?.status === "authenticated") {
          // Stop polling and update UI immediately
          clearInterval(iv as any);
          delete authPollers.current[depId];
          setDeployments(prev => prev.map(d => d.id === depId ? { ...d, authStatus: "authenticated" } : d));
        }
      } catch {
        // ignore transient errors during polling
      }
    }, AUTH_POLL_MS);
    authPollers.current[depId] = iv;
  };

  const stopAuthPolling = (depId: string) => {
    const h = authPollers.current[depId];
    if (h) {
      clearInterval(h as any);
      delete authPollers.current[depId];
    }
  };

  const stopAllAuthPolling = () => {
    Object.values(authPollers.current).forEach(h => clearInterval(h as any));
    authPollers.current = {};
  };

  const waitForAgentReady = async (depId: string, baseUrl: string) => {
    // Show "Starting…" state with spinner
    setDeployments(prev => prev.map(d => d.id === depId ? { ...d, authStatus: 'warming_up' } : d));
    const start = Date.now();
    while (Date.now() - start < WARMUP_MAX_MS) {
      try {
        const res = await fetch(`${baseUrl}/healthz`, { credentials: "include", cache: "no-store" });
        if (res.ok) {
          // Mark as ready to auth
          setDeployments(prev => prev.map(d => d.id === depId ? { ...d, authStatus: 'needs_auth' } : d));
          return true;
        }
      } catch {
        // ignore until timeout
      }
      await new Promise(r => setTimeout(r, WARMUP_POLL_MS));
    }
    setDeployments(prev => prev.map(d => d.id === depId ? { ...d, authStatus: 'error', authError: 'Agent not ready yet' } : d));
    return false;
  };

  const logoutMachine = async () => {
    try {
      const raw = localStorage.getItem('userProfile');
      if (!raw) return; // nothing to do
      const userData = JSON.parse(decodeWithBase64(raw));
      const logoutJson = {
        SessionID: userData["SessionID"],
        MACAddress: userData['MACAddress'],
        ServerID: LLServerID,
        MobileNumber: userData['MobileNumber'],
      };
      const resp = await axios({
        method: 'post',
        url: LLServerIP + 'logOutMachine',
        data: logoutJson,
        headers: { 'Content-Type': 'application/json' },
      });
      return resp.data;
    } catch (error) {
      // best-effort; don't block logout if API fails
      console.warn('logOutMachine call failed:', error);
      return null;
    }
  };

  const handleLogout = async () => {
    const ok = window.confirm(LanguageString("324"));
    if (!ok) return;
    // Call backend to mark this device/session logged out
    await logoutMachine();
    // Then clear local caches/state
    await clearAllClientData();
    try { window.postMessage({ type: 'oauth_done', ok: false, base: '' }, '*'); } catch { }
    onLogout();
    try {
      navigate('/emailtracker', { replace: true });
    } catch (e) {
      // Fallback if router is unavailable in this context
      window.location.assign('/emailtracker');
    }
  };


  const saveUserDevice = async () => {
    const raw = localStorage.getItem('userProfile');
    if (!raw) return;
    const userData = JSON.parse(decodeWithBase64(raw));
    // Helpers to map API items to UI deployments
    let dataJson = {
      "SessionID": userData["SessionID"],
      "MACAddress": userData["MACAddress"],
      "CountryCode": "274343",
      "TokenID": "token",
      "ServerID": LLServerID,
      "FirstName": "Cosmitude",
      "LastName": "Email Tracker",
    }
    let payload = new FormData();
    payload.append('Data', JSON.stringify(dataJson));
    return axios({
      method: 'post',
      url: LLServerIP + 'saveUserDevice',
      data: payload,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        return error;
      });
  }

  const NewForumCreation = (Botnumber) => {
    const raw = localStorage.getItem('userProfile');
    if (!raw) return;
    const userData = JSON.parse(decodeWithBase64(raw));
    const currentEpochTime = Math.floor(Date.now() / 1000);
    let tempJson = {
      "SessionID": userData['SessionID'],
      "MACAddress": userData['MACAddress'],
      "AddUsers": Botnumber,
      "CloneTemplateFromForum": false,
      "UPI": null,
      "TemplateName": TemplateName,
      "ForumName": "Cosmitude Email Tracker",
      "TemplateID": TemplateId,
      "ForumDomain": "Others",
      "ChatForum": false,
      "Owner": userData['UserName'],
      "ForumDescription": JSON.stringify("Cosmitude Email Tracker Forum"),
      "Time": currentEpochTime,
      "ForumType": "Protected",
      "ServerID": FSServerID,
    }
    let payload = new FormData();
    payload.append('Data', JSON.stringify(tempJson));
    return axios({
      method: 'post',
      url: FSServerIP + "newForum",
      data: payload,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        return error;
      });
  }

  const addBotAsAdmin = async (BotNumber, ForumID) => {
    try {
      const adminJson = {
        "ForumID": ForumID,
        "AddAdminsToForum": BotNumber,
        "Creator": ["False"],
        "Modifier": ["True"],
        "Approver": ["True"],
        "Priority": [0, 0],
      }
      const data = await addingForumAdminsExternally(adminJson);
      if (data["ErrorCode"] === 1056) {
        return true;
      }
      else return false;
    } catch (error) {

    }
  }

  const sendLimitData = async (forumData, type, limit) => {
    try {
      if (!type || !limit || !forumData) return;
      let jsonToSend = {};
      let listOfValues = [];
      listOfValues.push(encodeWithBase64(type));
      listOfValues.push(encodeWithBase64(limit));
      let AdminTemplateDetails = forumData['AdminFlow'];
      const FlowName = TemplateName + '_' + 'AddLimits';
      const flowDetails = AdminTemplateDetails[FlowName];
      const fID = flowDetails['FID'];
      const formatName = flowDetails['Formats'][0];
      const forumID = forumData['ForumID']
      let formatDetailsWithRows = AdminTemplateDetails[formatName];
      let i = 0;
      for (var key in formatDetailsWithRows) {
        let eachRow = formatDetailsWithRows[key];
        for (var key1 in eachRow) {
          let formatDetails = eachRow[key1];
          if (formatDetails['type'] != 'LABEL' && formatDetails['type'] != 'SPAN' && formatDetails['type'] !== 'IMG') {
            let associatedID = formatDetails['ID'];
            jsonToSend[associatedID] = listOfValues[i];
            i++;
          }
        }
      }
      await BridgeSending(jsonToSend, FlowName, TemplateId, forumID, fID);
    } catch (error) {
      console.error(error)
    }
  }

  const sendBlockedDomainData = async (forumData, domainData) => {
    try {
      if (!forumData || !domainData) return;
      let jsonToSend = {};
      let listOfValues = [];
      listOfValues.push(encodeWithBase64(JSON.stringify(domainData)));
      let AdminTemplateDetails = forumData['AdminFlow'];
      const FlowName = TemplateName + '_' + 'BlockedDomains';
      const flowDetails = AdminTemplateDetails[FlowName];
      const fID = flowDetails['FID'];
      const formatName = flowDetails['Formats'][0];
      const forumID = forumData['ForumID']
      let formatDetailsWithRows = AdminTemplateDetails[formatName];
      let i = 0;
      for (var key in formatDetailsWithRows) {
        let eachRow = formatDetailsWithRows[key];
        for (var key1 in eachRow) {
          let formatDetails = eachRow[key1];
          if (formatDetails['type'] != 'LABEL' && formatDetails['type'] != 'SPAN' && formatDetails['type'] !== 'IMG') {
            let associatedID = formatDetails['ID'];
            jsonToSend[associatedID] = listOfValues[i];
            i++;
          }
        }
      }
      await BridgeSending(jsonToSend, FlowName, TemplateId, forumID, fID);
    } catch (error) {
      console.error(error)
    }
  }

  const BridgeSending = async (BridgeData, flowName, templateID, forumID, fID) => {
    let uuid = uuidv4();
    const userProfile = JSON.parse(decodeWithBase64(localStorage.getItem('userProfile')));
    const SessionID = userProfile.SessionID;

    let bridgeJson = {
      'ForumID': forumID,
      'SessionID': SessionID,
      'MACAddress': userProfile.MACAddress,
      'Time': "6516516156161",
      'ScheduledDateTime': "now",
      'ScheduledBoolean': 0,
      'FlowID': flowName,
      'EnableChat': 0,
      'FlowType': "Custom",
      'BridgeForward': 0,
      'TemplateID': templateID,
      'TextCount': 15,
      'ImageCount': 0,
      'InvoiceID': "",
      'DocumentCount': 0,
      'User': false,
      'VideoCount': 0,
      "ServerID": FSServerID,
      'ReplyBridgeID': '',
      'HiddenFlow': false,
      'BilledForum': "",
      'TempBridgeId': uuid,
      'FID': fID,
      "SentTo": "0"
    }
    bridgeJson[flowName] = BridgeData;
    const payload = new FormData();
    payload.append('Data', JSON.stringify(bridgeJson));
    const ForumData = await SendingBridgeUpdate(payload, 'saveForumBridges2');
    if (ForumData["ErrorCode"] === 3112) {
      toast({
        title: "Credits Expired",
        description: "Your credits have expired. Please contact the admin.",
        variant: "destructive",
      });
    }
  }
  const extractIdFromName = (name?: string) => {
    if (!name) return undefined;
    const m = name.match(/^(?:agent|script)-(.+?)-deploy$/);
    return m?.[1];
  };
  const mapStatus = (s?: string): Deployment['status'] => {
    const up = (s || '').toUpperCase();
    if (up === 'STOPPED') return 'stopped';
    if (up === 'DEPLOYED' || up === 'RUNNING') return 'running';
    return 'error';
  };
  const mapApiItemToDeployment = async (item: any): Promise<Deployment> => {
    const id = String(item?.taskid || item?.id || extractIdFromName(item?.deployment) || crypto.randomUUID());
    const created = typeof item?.timestamp === 'number' ? new Date(item.timestamp * 1000) : new Date();
    const name = item?.name || item?.deployment || `Agent ${id}`;
    const base = agentBase(id);


    let authStatus: Deployment['authStatus'] = 'unknown';
    try {
      const authRes = await fetch(`${base}/auth/status`, { credentials: "include" });
      const authJson = await authRes.json().catch(() => ({} as any));
      authStatus = authJson?.status === 'authenticated' ? 'authenticated' : 'needs_auth';
    } catch {
      authStatus = 'unknown';
    }

    return {
      id,
      name,
      status: mapStatus(item?.status),
      createdAt: created.toISOString().split('T')[0],
      emailsSent: 0,
      sheetsUrl: item?.sheetsUrl || '',
      authStatus,
    };
  };


  // Load deployments for this user from backend
  useEffect(() => {
    (async () => {
      loadDeploymentsFromServer();
      // try {
      //   const raw = localStorage.getItem('userProfile');
      //   if (!raw) return;
      //   const userData = JSON.parse(decodeWithBase64(raw));
      //   const payload = { sessionid: userData.SessionID, macaddress: userData.MACAddress };
      //   const res = await fetch(`${resolveDeployer()}/deployments`, {
      //     method: 'POST',
      //     headers: { 'Content-Type': 'application/json' },
      //     credentials: 'include',
      //     body: JSON.stringify(payload),
      //   });
      //   if (!res.ok) throw new Error(`HTTP ${res.status}`);
      //   const data = await res.json();
      //   const list = Array.isArray(data?.deployments) ? data.deployments : [];
      //   const mapped = await Promise.all(list.map(mapApiItemToDeployment));
      //   mapped.forEach(async (d) => {
      //     if (d.status === 'running') {
      //       try {
      //         if (!d.id) return;
      //         const base = agentBase(d.id);
      //         const resp = await fetch(`${base}`);
      //         if (resp.status !== 200) {
      //           setDeployments(prev => prev.map(dep => dep.id === d.id ? { ...dep, status: "deploying" } : dep));
      //           setIsAgentDeploying(true);
      //           return;
      //         }
      //         try { localStorage.setItem('oauth_agent_base', base); } catch { }
      //         checkAuthForDeployment(d, base);
      //       } catch (err) {
      //         console.error(`Error preparing proxy base for deployment ${d.id}:`, err);
      //       }
      //     }
      //     else if (d.status === 'deploying') {
      //       try {
      //         if (!d.id) return;
      //         const base = agentBase(d.id);
      //         const resp = await fetch(`${base}`);
      //         if (resp.status === 200) {
      //           setDeployments(prev => prev.map(dep => dep.id === d.id ? { ...dep, status: "running" } : dep));
      //           setIsAgentDeploying(false);
      //           return;
      //         }
      //         // setDeployments(prev => prev.map(d => d.id === depId ? { ...d, authStatus: "authenticated" } : d));
      //         // Persist base for OAuth callback correlation and check current auth
      //       } catch (err) {
      //         console.error(`Error preparing proxy base for deployment ${d.id}:`, err);
      //       }
      //     }
      //   })
      //   setDeployments(mapped);
      // } catch (err) {
      //   console.error('Status fetch error:', err);
      // }
    })();
  }, []);

  const loadDeploymentsFromServer = async () => {
    try {
      const raw = localStorage.getItem('userProfile');
      if (!raw) return;
      const userData = JSON.parse(decodeWithBase64(raw));
      const payload = { sessionid: userData.SessionID, macaddress: userData.MACAddress };
      const res = await fetch(`${resolveDeployer()}/deployments`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(payload),
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      const list = Array.isArray(data?.deployments) ? data.deployments : [];
      const mapped = await Promise.all(list.map(mapApiItemToDeployment));
      mapped.forEach(async (d) => {
        if (d.status === 'running') {
          try {
            if (!d.id) return;
            const base = agentBase(d.id);
            const resp = await fetch(`${base}`);
            if (resp.status !== 200) {
              setDeployments(prev => prev.map(dep => dep.id === d.id ? { ...dep, status: "deploying" } : dep));
              setIsAgentDeploying(true);
              return;
            }
            try { localStorage.setItem('oauth_agent_base', base); } catch { }
            checkAuthForDeployment(d, base);
          } catch (err) {
            console.error(`Error preparing proxy base for deployment ${d.id}:`, err);
          }
        }
        else if (d.status === 'deploying') {
          try {
            if (!d.id) return;
            const base = agentBase(d.id);
            const resp = await fetch(`${base}`);
            if (resp.status === 200) {
              setDeployments(prev => prev.map(dep => dep.id === d.id ? { ...dep, status: "running" } : dep));
              setIsAgentDeploying(false);
              try { localStorage.setItem('oauth_agent_base', base); } catch { }
              checkAuthForDeployment(d, base);
              return;
            }
          } catch (err) {
            console.error(`Error preparing proxy base for deployment ${d.id}:`, err);
          }
        }
      })
      setDeployments(mapped);
    } catch (error) {
      console.log(error)
    }
  }
  const checkAuthForDeployment = async (dep: Deployment, baseUrl: string) => {
    try {
      const base = baseUrl;
      const res = await fetch(`${base}/auth/status`, { credentials: "include" });
      const data = await res.json();
      const next: Deployment['authStatus'] = data?.status === 'authenticated' ? 'authenticated' : 'needs_auth';
      handleAuthList(dep.id, data?.status === 'authenticated' ? true : false);
      setDeployments(prev => prev.map(d => {
        if (d.id === dep.id && d.authStatus !== next) {
          return { ...d, authStatus: next };
        }
        return d;
      }));
    } catch (_e: any) {
      // Agent may still be starting—treat as not yet connected instead of error
      setDeployments(prev => prev.map(d => {
        if (d.id === dep.id && d.authStatus !== 'needs_auth') {
          return { ...d, authStatus: 'needs_auth', authError: undefined };
        }
        return d;
      }));
    }
  };

  const handleAuthList = (id, status) => {
    try {
      setDeploymentAunthenticated(prev => {
        if (status) {
          // Remove id
          return prev.filter(d => d !== id);
        } else {
          // Add id if not already present
          if (!prev.includes(id)) {
            return [...prev, id];
          }
          return prev;
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const deploymentsRef = useRef(deployments);
  useEffect(() => {
    deploymentsRef.current = deployments;
  }, [deployments]);

  useEffect(() => {
    // Run initial check after 1s, then poll cleanly every 3s
    const initialTimer = setTimeout(() => {
      checkFourDeployment();
    }, 1000);

    const interval = setInterval(() => {
      checkFourDeployment();
    }, 3000);

    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);

  const loadDeployments = async () => {
    loadDeploymentsFromServer();
  };

  const checkFourDeployment = () => {
    const currentList = deploymentsRef.current || [];
    if (currentList.length === 0) return;

    currentList.forEach(async (d) => {
      if (d.status === 'running') {
        try {
          if (!d.id) {
            loadDeployments();
            return;
          }
          const base = agentBase(d.id);
          const resp = await fetch(`${base}`);
          if (resp.status !== 200) {
            setDeployments(prev => prev.map(dep => dep.id === d.id ? { ...dep, status: "deploying" } : dep));
            setIsAgentDeploying(true);
            return;
          }
          setIsAgentDeploying(false);
          // Persist base for OAuth callback correlation and check current auth
          try { localStorage.setItem('oauth_agent_base', base); } catch { }
          checkAuthForDeployment(d, base);
        } catch (err) {
          console.error(`Error preparing proxy base for deployment ${d.id}:`, err);
        }
      }
      else if (d.status === 'deploying') {
        try {
          if (!d.id) {
            loadDeployments();
            return;
          }
          const base = agentBase(d.id);
          const resp = await fetch(`${base}`);
          if (resp.status === 200) {
            setDeployments(prev => prev.map(dep => dep.id === d.id ? { ...dep, status: "running" } : dep));
            setIsAgentDeploying(false);
            try { localStorage.setItem('oauth_agent_base', base); } catch { }
            checkAuthForDeployment(d, base);
            return;
          }
          setIsAgentDeploying(true);
        } catch (err) {
          console.error(`Error preparing proxy base for deployment ${d.id}:`, err);
        }
      }
    });
  };


  // Persisted OAuth result handler (to cover dashboard not mounted during redirect)
  useEffect(() => {
    try {
      const raw = localStorage.getItem('oauth_last_result');
      if (!raw) return;
      const parsed = JSON.parse(raw);
      const base: string = parsed?.base || '';
      const ok: boolean = !!parsed?.ok;
      const m = base.match(/\/agent\/([^/]+)\/proxy/);
      const idFromBase = m?.[1];
      if (!idFromBase) return;
      setDeployments(prev => prev.map(d =>
        d.id === idFromBase ? { ...d, authStatus: ok ? 'authenticated' : 'error' } : d
      ));
    } catch { }
  }, []);

  useEffect(() => {
    const onMsg = (e: MessageEvent) => {
      if ((e.data as any)?.type === 'oauth_done') {
        const base = (e.data as any)?.base || localStorage.getItem('oauth_agent_base') || '';
        const ok = !!(e.data as any)?.ok;
        const m = base.match(/\/agent\/([^/]+)\/proxy/);
        const idFromBase = m?.[1];
        if (!idFromBase) return;
        stopAuthPolling(idFromBase);
        setDeployments(prev => prev.map(d =>
          d.id === idFromBase ? { ...d, authStatus: ok ? 'authenticated' : 'error' } : d
        ));
      }
    };
    window.addEventListener('message', onMsg);
    return () => window.removeEventListener('message', onMsg);
  }, []);

  const escapeHtml = (s: string) =>
    (s ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");

  const toHtmlEmailBody = (plain: string) => {
    const safe = escapeHtml(plain ?? "");

    // Detect URLs (http/https) and wrap them in anchor tags
    const urlRe = /(https?:\/\/[^\s<]+)/g;

    const linked = safe.replace(urlRe, (url) => {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });

    // Preserve line breaks in HTML emails
    return linked.replace(/\r\n|\n|\r/g, "<br/>");
  };

  const handleDeploy = async (deployment: { name: string; sheetsUrl: string; groupEmail: string, subject: string, body: string, emailLimit: number, domains }) => {
    try {
      // load userProfile
      // Enforce maximum of 1 deployment
      if (deployments.length >= 1) {
        window.alert(LanguageString("1985"));
        setShowDeployDialog(false);
        return;
      }

      const raw = localStorage.getItem('userProfile');
      if (!raw) throw new Error('no userProfile in localStorage');
      const userData = JSON.parse(decodeWithBase64(raw));
      const sessionid = userData.SessionID;
      const macaddress = userData.MACAddress;
      let agentId = '';
      const image = 'python:3.11-slim';
      let MobileNumber, userName, forumID = "";
      let device = await saveUserDevice();
      console.log('Device saved:', device);
      if (device.ErrorCode === 1166) {
        // Handle specific error case
        const deviceInfo = device.ErrorMessage
        MobileNumber = deviceInfo.MobileNumber
        userName = deviceInfo.UserName
        agentId = MobileNumber
        let forumInfo = await NewForumCreation([MobileNumber]);
        if (forumInfo.ErrorCode === 1011) {
          forumID = forumInfo.ErrorMessage.ForumID
        }
        sendLimitData(forumInfo['ErrorMessage'], 'Email Daily Limit', deployment.emailLimit)
        if (deployment.domains && deployment.domains.length > 0) {
          sendBlockedDomainData(forumInfo['ErrorMessage'], { "blocked_domains": deployment.domains })
        }
      } else {
        toast({ variant: "destructive", title: LanguageString("1986") });
        return;
      }
      const adminDevice = await addBotAsAdmin([MobileNumber], forumID);
      if (!adminDevice) {
        toast({ variant: "destructive", title: LanguageString("1986") });
        return;
      }
      // prepare payload using imported baseCode
      const redirectUri = window.location.origin; // Option B: use homepage as redirect
      const htmlBody = toHtmlEmailBody(deployment.body || "");
      const payload = {
        fileName: 'gmail_group_monitor.py',
        script: baseCode(deployment.sheetsUrl, deployment.groupEmail, MobileNumber, userName, forumID, userData.Password, deployment.subject, htmlBody, deployment.emailLimit),
        sessionid,
        macaddress,
        agentId,
        image,
        env: { REDIRECT_URI: redirectUri },
      };
      let isScript = payload['script']
      console.log("isScript", isScript)
      const resp = await fetch(`${resolveDeployer()}/agent/deploy`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(payload),
      });
      if (!resp.ok) {
        const text = await resp.text();
        throw new Error(`HTTP ${resp.status}: ${text}`);
      }
      const data = await resp.json();
      console.log('Script deployed:', data);
      localStorage.setItem('scriptId', data.id);
      // add new deployment to list (force default name)
      const defaultName = 'Cosmitude Email tracker agent';
      const newDeployment: Deployment = {
        id: data.id,
        name: deployment.name,
        status: 'deploying',
        createdAt: new Date().toISOString().split('T')[0],
        emailsSent: 0,
        sheetsUrl: deployment.sheetsUrl,
        authStatus: 'needs_auth',
        groupEmail: deployment.groupEmail,
      };
      setDeployments(prev => [...prev, newDeployment]);
      setIsAgentDeploying(true);
      setShowDeployDialog(false);
    } catch (err: any) {
      console.error('Error deploying script:', err);
      window.alert(`${LanguageString("1737")}: ${err.message}`);
    }
  };

  const handleEmailSender = async (emaildeployment: EmailDeployment) => {
    console.log("Hello")
    try {
      // load userProfile
      // Enforce maximum of 1 deployment
      if (deployments.length >= 1) {
        window.alert(LanguageString("1985"));
        setShowEmailDialog(false);
        return;
      }

      // Validate inputs from the dialog
      if (!SHEETS_RE.test(emaildeployment.sheetsUrl)) {
        window.alert(LanguageString("1987"));
        setShowEmailDialog(false);
        return;
      }
      if (!emaildeployment.subject || !emaildeployment.subject.trim()) {
        window.alert(LanguageString("1988"));
        return;
      }
      if (!emaildeployment.body || !emaildeployment.body.trim()) {
        window.alert(LanguageString("1989"));
        return;
      }

      const raw = localStorage.getItem('userProfile');
      if (!raw) throw new Error('no userProfile in localStorage');
      const userData = JSON.parse(decodeWithBase64(raw));
      const sessionid = userData.SessionID;
      const macaddress = userData.MACAddress;
      let agentId = '';
      const image = 'python:3.11-slim';
      let MobileNumber = "";
      let userName = "";
      let forumID = "";
      let device = await saveUserDevice();
      console.log('Device saved:', device);
      if (device.ErrorCode === 1166) {
        // Handle specific error case
        const deviceInfo = device.ErrorMessage
        MobileNumber = deviceInfo.MobileNumber
        userName = deviceInfo.UserName
        agentId = MobileNumber
        let forumInfo = await NewForumCreation([MobileNumber]);
        if (forumInfo.ErrorCode === 1011) {
          forumID = forumInfo.ErrorMessage.ForumID
        }

      } else {
        toast({ variant: "destructive", title: LanguageString("1986") });
        return;
      }
      // prepare payload using imported baseCode
      const redirectUri = `${window.location.origin}/oauth2callback`;
      const script = emailCode(
        emaildeployment.sheetsUrl,
        MobileNumber,
        userName,
        forumID,
        "" // avoid embedding password in generated agent code
      );

      const payload = {
        fileName: 'gmail_group_monitor.py',
        script,
        sessionid,
        macaddress,
        agentId,
        image,
        env: {
          REDIRECT_URI: redirectUri,
          SHEETS_URL: emaildeployment.sheetsUrl,
          SUBJECT_TEMPLATE: emaildeployment.subject,
          BODY_TEMPLATE: emaildeployment.body,
        },
      };
      const resp = await fetch(`${resolveDeployer()}/agent/deploy`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(payload),
      });
      if (!resp.ok) {
        const text = await resp.text();
        throw new Error(`HTTP ${resp.status}: ${text}`);
      }
      const data = await resp.json();
      console.log('Script deployed:', data);
      localStorage.setItem('scriptId', data.id);
      // add new deployment to list (force default name)
      const defaultName = 'Cosmitude Email tracker agent';
      const newDeployment: Deployment = {
        id: data.id,
        name: defaultName,
        status: 'running',
        createdAt: new Date().toISOString().split('T')[0],
        emailsSent: 0,
        sheetsUrl: emaildeployment.sheetsUrl,
        authStatus: 'needs_auth'
        // groupEmail: deployment.groupEmail,
      };
      setDeployments(prev => [...prev, newDeployment]);
      setShowEmailDialog(false);
    } catch (err: any) {
      console.error('Error deploying script:', err);
      window.alert(`${LanguageString("1737")}: ${err.message}`);
    }
  }
  const handleUpdateGroup = async (deployment: Deployment) => {
    try {
      if (deployment.status !== 'running') {
        window.alert(LanguageString("1990"));
        return;
      }
      if (!/@/.test(groupEmailInput)) {
        toast({ title: 'Invalid email', description: 'Enter a valid Google Group address.', variant: 'destructive' });
        return;
      }
      setSavingGroup(true);
      const base = agentBase(deployment.id);
      const res = await fetch(`${base}/config/group`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ email: groupEmailInput })
      });
      if (!res.ok) {
        const txt = await res.text().catch(() => '');
        throw new Error(`HTTP ${res.status}: ${txt}`);
      }
      setDeployments(prev => prev.map(d => d.id === deployment.id ? { ...d, groupEmail: groupEmailInput } : d));
      toast({ title: 'Google Group updated', description: groupEmailInput });
      setShowGroupFor(null);
    } catch (e: any) {
      toast({ title: 'Failed to update group', description: e?.message || String(e), variant: 'destructive' });
    } finally {
      setSavingGroup(false);
    }
  };

  const handleControl = async (
    action: 'start' | 'stop' | 'restart' | 'delete',
    deployment: Deployment
  ) => {
    try {
      // Load sessionid and macaddress from localStorage
      const raw = localStorage.getItem('userProfile');
      if (!raw) throw new Error('no userProfile in localStorage');
      const userData = JSON.parse(decodeWithBase64(raw));
      const sessionid = userData.SessionID;
      const macaddress = userData.MACAddress;

      // Confirm stop or delete actions
      if (action === 'stop' && !window.confirm(LanguageString("1991"))) return;
      if (action === 'delete' && !window.confirm(LanguageString("1992"))) return;

      const id = deployment.id;
      if (!id) throw new Error('Missing deployment id');

      // Use legacy /script endpoints directly (avoid agent fallback to prevent CORS/405 issues)
      const method = action === 'delete' ? 'DELETE' : 'POST';
      const taskid = id;
      if (!taskid) throw new Error('Missing task id (BotDetails.number or scriptId)');
      let jsonaa = { sessionid, macaddress, taskid }
      const url = `${ipDeployer}/script/${action}`;
      console.log(`Calling ${url} with`, jsonaa);
      let res: Response;
      try {
        res = await fetch(url, {
          method,
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify(jsonaa)
        });
      } catch (e: any) {
        throw new Error(`Network error calling ${url}: ${e?.message || e}`);
      }

      if (!res.ok) {
        const text = await res.text().catch(() => '');
        throw new Error(`HTTP ${res.status}: ${text || 'Request failed'}`);
      }

      const json = await res.json().catch(() => ({} as any));
      if (!json || (json.status && typeof json.status !== 'string')) {
        // Some endpoints may return plain text; ignore strict shape
      }
      if (action === 'stop') {
        setDeployments(prev => prev.map(d => d.id === id ? { ...d, status: 'stopped' } : d));
        toast({ title: LanguageString("1742"), description: `${LanguageString("Device")} ${deployment.name} ${LanguageString("1742")}.` });
      } else if (action === 'start' || action === 'restart') {
        setDeployments(prev => prev.map(d => d.id === id ? { ...d, status: 'running' } : d));
        toast({ title: action === 'start' ? LanguageString("1994") : LanguageString("1995"), description: `${LanguageString("Device")} ${deployment.name} ` + action === 'start' ? LanguageString("1994") : LanguageString("1995") });
      } else if (action === 'delete') {
        setDeployments(prev => prev.filter(d => d.id !== id));
        toast({ title: LanguageString("Deleted"), description: `${LanguageString("Device")} ${deployment.name} ${LanguageString("Deleted")}` });
      }
    } catch (err: any) {
      console.error('Control error:', err);
      toast({ title: `${action[0].toUpperCase() + action.slice(1)} failed`, description: err?.message || String(err), variant: 'destructive' });
    }
  };

  const handleInitiateAuth = async (deployment: Deployment) => {
    try {
      if (deployment.status !== 'running') {
        window.alert(LanguageString("1990"));
        return;
      }
      const base = agentBase(deployment.id);
      console.log("Initiating OAuth flow with base URL:", base);
      // const base = "http://192.168.1.111:8888/agent/" + deployment.id +"/proxy";
      try { localStorage.setItem('oauth_agent_base', base); } catch { }

      const startOAuth = async () => {
        setDeployments(prev => prev.map(d => d.id === deployment.id ? { ...d, authStatus: 'authenticating', authError: null } : d));
        const resp = await fetch(`${base}/auth`, { credentials: "include" });
        console.log("Auth response:", resp);
        const data = await resp.json().catch(() => ({} as any));
        if (data?.status === 'needs_code' && data?.url) {
          window.open(data.url as string, '_blank', 'noopener');
          beginAuthPolling(deployment.id, base);
        } else if (data?.status === 'authenticated') {
          stopAuthPolling(deployment.id);
          setDeployments(prev => prev.map(d => d.id === deployment.id ? { ...d, authStatus: 'authenticated' } : d));
          toast({ title: LanguageString("1996") });
        } else {
          stopAuthPolling(deployment.id);
          setDeployments(prev => prev.map(d => d.id === deployment.id ? { ...d, authStatus: 'error', authError: 'Unexpected response from auth endpoint' } : d));
          window.alert(LanguageString("1997"));
        }
      };

      // If the agent isn’t ready yet, wait for it before starting OAuth
      try {
        const ping = await fetch(`${base}/healthz`, { credentials: "include", cache: "no-store" });
        if (!ping.ok) throw new Error(`not ready: ${ping.status}`);
        await startOAuth();
      } catch {
        toast({
          title: LanguageString("1998"),
          description: LanguageString("1999"),
        });
        const ready = await waitForAgentReady(deployment.id, base);
        if (ready) {
          await startOAuth();
        }
      }
    } catch (e: any) {
      stopAuthPolling(deployment.id);
      setDeployments(prev => prev.map(d => d.id === deployment.id ? { ...d, authStatus: 'error', authError: e?.message || String(e) } : d));
      window.alert(`${LanguageString("2000")}: ${e?.message || e}`);
    }
  };
  // Opportunistically refresh auth status when tab regains focus/visibility
  useEffect(() => {
    const refreshIfAuthenticating = () => {
      deployments.forEach((d) => {
        if (d.status === 'running' && d.authStatus === 'authenticating') {
          const base = agentBase(d.id);
          checkAuthForDeployment(d, base);
        }
      });
    };
    const onFocus = () => refreshIfAuthenticating();
    const onVisible = () => {
      if (document.visibilityState === 'visible') refreshIfAuthenticating();
    };
    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      window.removeEventListener('focus', onFocus);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [deployments]);

  // Clean up pollers on unmount
  useEffect(() => {
    return () => {
      stopAllAuthPolling();
    };
  }, []);

  const handleRevokeAuth = async (deployment: Deployment) => {
    try {
      if (deployment.status !== 'running') {
        window.alert(LanguageString("1990"));
        return;
      }
      const ok = window.confirm(LanguageString("2001"));
      if (!ok) return;
      const base = agentBase(deployment.id);
      const resp = await fetch(`${base}/revoke`, { method: 'POST', credentials: 'include' });
      if (!resp.ok) {
        const text = await resp.text();
        throw new Error(`HTTP ${resp.status}: ${text}`);
      }
      const data = await resp.json().catch(() => ({}));
      setDeployments(prev => prev.map(d => d.id === deployment.id ? { ...d, authStatus: 'needs_auth' } : d));
      window.alert(LanguageString("2001"));
    } catch (e: any) {
      window.alert(`${LanguageString("2002")}: ${e?.message || e}`);
    }
  };

  const handleSendReminders = async (deployment: Deployment) => {
    // Helper to detect "looks like success" from plain-text bodies
    const looksLikeSuccess = (txt: string) => {
      if (!txt) return false;
      return /sent|remind|trigger|ok|success/i.test(txt);
    };

    try {
      if (deployment.status !== 'running') {
        window.alert(LanguageString("1990"));
        return;
      }
      setSendingReminders(true);
      const base = agentBase(deployment.id);

      // Try to push custom subject/body first (optional endpoint)
      try {
        const resCfg = await fetch(`${base}/config/reminder`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ subject: reminderSubject, body: reminderBody })
        });
        if (!resCfg.ok && resCfg.status !== 404) {
          const txt = await resCfg.text().catch(() => '');
          console.warn('[reminder] config endpoint returned non-OK:', resCfg.status, txt);
          // Do not abort — we can still send with defaults
        }
      } catch (e) {
        console.warn('[reminder] config not applied (continuing with defaults):', e);
      }

      // Invoke reminder run
      let res: Response | null = null;
      let textBody = '';
      try {
        res = await fetch(`${base}/manual/remind`, { credentials: 'include' });
        textBody = await res.text().catch(() => '');
      } catch (e: any) {
        console.log('[reminder] manual/remind fetch error:', e);
        // Network layer failed; as a fallback, check if the agent is healthy and show a neutral toast
        try {
          const ping = await fetch(`${base}/healthz`, { credentials: 'include', cache: 'no-store' });
          if (ping.ok) {
            toast({
              title: LanguageString("2004"),
              description: LanguageString("2005"),
            });
            setShowRemindFor(null);
            return;
          }
        } catch {/* ignore */ }
        // If health also fails, surface an error
        toast({ title: LanguageString("2006"), description: e?.message || String(e), variant: 'destructive' });
        return;
      }

      // Parse JSON if available, otherwise use plain text
      let data: any = {};
      try {
        data = JSON.parse(textBody || '{}');
      } catch {
        // not JSON — that's fine
      }

      // Success conditions:
      // 1) HTTP 2xx
      // 2) Non-2xx but body suggests success (common when server writes logs then returns error)
      // 3) Non-2xx and body empty, but health is OK (optimistic success)
      if (res && res.ok) {
        toast({ title: LanguageString("2004"), description: data?.status || looksLikeSuccess(textBody) ? (data?.status || LanguageString("2007")) : LanguageString("2007") });
        setShowRemindFor(null);
        return;
      }

      // res not ok — try to infer success
      if (looksLikeSuccess(textBody)) {
        toast({
          title: LanguageString("2004"),
          description: data?.status || LanguageString("2008"),
        });
        setShowRemindFor(null);
        return;
      }

      try {
        const ping = await fetch(`${base}/healthz`, { credentials: 'include', cache: 'no-store' });
        if (ping.ok) {
          toast({
            title: LanguageString("2004"),
            description: LanguageString("2009"),
          });
          setShowRemindFor(null);
          return;
        }
      } catch {/* ignore */ }

      // True failure
      const errDetail = data?.error || textBody || `HTTP ${res?.status || '???'}`;
      toast({ title: LanguageString("2010"), description: errDetail, variant: 'destructive' });
    } catch (e: any) {
      toast({ title: LanguageString("2010"), description: e?.message || String(e), variant: 'destructive' });
    } finally {
      setSendingReminders(false);
    }
  };

  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'running':
        return (
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border border-emerald-500/20 shadow-sm">
            <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
            {LanguageString("1741") || "Running"}
          </span>
        );
      case 'stopped':
        return (
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300 border border-slate-200 dark:border-slate-700">
            <span className="w-2 h-2 rounded-full bg-slate-400" />
            {LanguageString("1742") || "Stopped"}
          </span>
        );
      case 'deploying':
        return (
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-amber-500/10 text-amber-600 dark:text-amber-400 border border-amber-500/20 animate-pulse">
            <span className="w-2 h-2 rounded-full bg-amber-500 animate-ping" />
            {LanguageString("2066") || "Deploying..."}
          </span>
        );
      case 'error':
        return (
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-rose-500/10 text-rose-600 dark:text-rose-400 border border-rose-500/20">
            <span className="w-2 h-2 rounded-full bg-rose-500" />
            {LanguageString("1993") || "Error"}
          </span>
        );
      default:
        return (
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-slate-100 text-slate-600 border border-slate-200">
            {LanguageString("2011") || "Unknown"}
          </span>
        );
    }
  };
  function openGmailCompose({ to, subject }: { to: string; subject?: string }) {
    const base = new URL("https://mail.google.com/mail/");
    base.searchParams.set("view", "cm");
    base.searchParams.set("fs", "1");
    base.searchParams.set("to", to);
    if (subject) base.searchParams.set("su", subject);

    const chooser = new URL("https://accounts.google.com/AccountChooser");
    chooser.searchParams.set("continue", base.toString());
    window.open(chooser.toString(), "_blank", "noopener");
  }

  const handleEmailClick = () => {
    openGmailCompose({
      to: "sales@cosmitude.com",
      subject: "Support Request",
    });
  };
  const handleDocumentClick = () => {
    setShowHelpDesk(false)
    setShowDocs(true)
  };

  const handleClickOnBlock = async (deployment: Deployment) => {
    setBlockedDomainList([])
    await fetchBlockedEmails(deployment);
    // setShowBlockedDomains(!showBlockedDomains);
    setAddingBlockedDomains(false);
    setBlockedDomain("")
    setBlockedFor(deployment.id);
  }

  const fetchBlockedEmails = async (deployment: Deployment) => {
    try {
      if (deployment.status !== 'running') {
        window.alert(LanguageString("1990"));
        return;
      }
      const base = agentBase(deployment.id);
      const res = await fetch(`${base}/config/getBlockedDomain`);
      if (!res.ok) {
        throw new Error("Failed to fetch blocked domains");
      }
      const data = await res.json();
      if (data['blocked_domains']) {
        let domainList = data['blocked_domains']
        if (domainList.length > 0) {
          setExistingBlockedDomain(domainList);
          setBlockedDomainList(domainList);
        }
        else {
          setExistingBlockedDomain([])
          setBlockedDomainList([])
        }
      }
      setShowBlockedDomains(!showBlockedDomains);
    } catch (error) {
      console.log("error", error)
    }
  }

  const updateBlockedEmails = async (deployment: Deployment) => {
    try {
      if (deployment.status !== 'running') {
        window.alert(LanguageString("1990"));
        return;
      } setAddingBlockedDomains(true)
      if (blockedDomainList.length === 0 && existingBlockedDomain.length === 0) {
        setAddingBlockedDomains(false);
        toast({ variant: "destructive", title: LanguageString("2198") });
        return;
      }
      const isSame =
        existingBlockedDomain.length === blockedDomainList.length &&
        existingBlockedDomain.every((val, i) => val === blockedDomainList[i]);
      if (isSame) {
        toast({ variant: "destructive", title: LanguageString("1664") });
        setAddingBlockedDomains(false);
        return;
      }
      const base = agentBase(deployment.id);
      const domainData = { 'blocked_domains': blockedDomainList }
      const res = await fetch(`${base}/config/updateBlockedDomain`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(domainData)
      });
      if (!res.ok) {
        setAddingBlockedDomains(false);
        toast({ variant: "destructive", title: LanguageString("1473") });
        return;
      }
      setAddingBlockedDomains(false);
      setExistingBlockedDomain(blockedDomainList);
      toast({ title: LanguageString("2199") });
    } catch (error) {
      setAddingBlockedDomains(false);
      console.log("error", error)
    }
  }

  const isValidDomain = (domain: string) => {
    const cleaned = domain.trim().toLowerCase().replace(/^@/, "");

    const domainRegex =
      /^(?!-)[a-z0-9-]{1,63}(?<!-)(\.[a-z]{2,})+$/;

    return domainRegex.test(cleaned);
  };

  const checkForValidDomain = (domain: string) => {
    if (!domain) return;

    const normalizedDomain = domain
      .trim()
      .toLowerCase()
      .replace(/^@/, "");

    if (!isValidDomain(normalizedDomain)) {
      toast({ variant: "destructive", title: LanguageString("2204") });
      return;
    }

    if (blockedDomainList.includes(normalizedDomain)) {
      toast({ title: LanguageString("2203") }); // already exists
      return;
    }
    setBlockedDomainList(prev => [...prev, normalizedDomain]);
    setBlockedDomain("");
  }

  type TypingTextProps = {
    text: string;
    as?: React.ElementType; // h1, h2, h3, p, span...
    speed?: number;
    repeat?: boolean;   // 👈 new
    pause?: number;
    className?: string;
  };

  const TypingText = ({
    text,
    as: Tag = "p",
    speed = 80,
    repeat = false,
    pause = 1200,
    className = "",
  }: TypingTextProps) => {
    const [displayed, setDisplayed] = React.useState("");

    React.useEffect(() => {
      let i = 0;
      let interval: number;
      let timeout: number;

      const startTyping = () => {
        interval = window.setInterval(() => {
          setDisplayed(text.slice(0, i + 1));
          i++;

          if (i === text.length) {
            clearInterval(interval);

            if (repeat) {
              timeout = window.setTimeout(() => {
                i = 0;
                setDisplayed("");
                startTyping();
              }, pause);
            }
          }
        }, speed);
      };

      startTyping();

      return () => {
        clearInterval(interval);
        clearTimeout(timeout);
      };
    }, [text, speed, repeat, pause]);

    return <Tag className={className}>{displayed}</Tag>;
  };

  const checkForEmailType = () => {
    try {
      let userProfile = JSON.parse(localStorage.getItem("userProfile"));
      if (!userProfile || !userProfile.emailId) {
        setMaxEmailLimit(500);
        return;
      }

      const emailId = userProfile.emailId.toLowerCase();
      const domain = emailId.split("@")[1];

      // List of common public email providers
      const publicDomains = [
        "gmail.com",
        "yahoo.com",
        "outlook.com",
        "hotmail.com",
        "icloud.com",
        "proton.me",
        "protonmail.com",
        "live.com"
      ];

      const isPublicEmail = publicDomains.includes(domain);
      if (isPublicEmail) {
        setMaxEmailLimit(500);
      }
      else {
        setMaxEmailLimit(2000);
      }

    } catch (error) {
      console.log(error)
    }
  }

  const handleEmailLimitClick = async (deployment: Deployment) => {
    try {
      if (deployment.status !== 'running') {
        window.alert(LanguageString("1990"));
        return;
      }
      const base = agentBase(deployment.id);
      const res = await fetch(`${base}/config/getDailyEmailLimit`);
      if (!res.ok) {
        throw new Error("Failed to fetch blocked domains");
      }
      const data = await res.json();
      if (data > 0) {
        setDailyEmailLimit(data)
        setCurrentEmailLimit(data);
      }
      else {
        setCurrentEmailLimit(450);
        setDailyEmailLimit(450);
      }
      checkForEmailType()
      setSelectedDeployment(deployment.id);
      setShowDailyEmailLimit(!showDailyEmailLimit);
    } catch (error) {
      console.log("error", error)
    }
  }

  const updateEmailLimit = async (deployment) => {
    try {
      if (deployment.status !== 'running') {
        window.alert(LanguageString("1990"));
        return;
      }
      if (currentEmailLimit === dailyEmailLimit) {
        toast(LanguageString("1664"));
        return;
      }
      setUpdatingEmailLimit(true);
      const base = agentBase(deployment.id);
      const emailLimitData = { 'limit': dailyEmailLimit };
      const res = await fetch(`${base}/config/updateDailyEmailLimit`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(emailLimitData)
      });
      if (!res.ok) {
        toast({ variant: "destructive", title: LanguageString("1473") });
        return;
      }
      setUpdatingEmailLimit(false);
      toast({ title: LanguageString("2213") })
    } catch (error) {

    }
  }

  return (
    <>
      <style>{`
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
      <TooltipProvider>
        <div className="min-h-screen bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-slate-100 transition-colors">
          {/* Header */}
          <header className="bg-white/80 dark:bg-slate-900/80 backdrop-blur-xl border-b border-slate-200/80 dark:border-slate-800/80 sticky top-0 z-50 shadow-sm">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="relative flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 py-3">
                {/* Brand row */}
                <div className="flex items-center justify-between w-full">
                  <div className="flex items-center space-x-3">
                    <div className="p-2.5 bg-gradient-to-tr from-blue-600 via-indigo-600 to-violet-600 text-white rounded-2xl shadow-md shadow-indigo-500/20">
                      <Mail className="h-6 w-6" />
                    </div>
                    <div>
                      <div className="flex items-center space-x-2">
                        <span className="text-2xl font-extrabold tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-slate-900 via-indigo-950 to-blue-900">
                          Email Tracker
                        </span>
                        {/* <span className="px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wider text-indigo-700 bg-indigo-50 border border-indigo-200/80 rounded-full shadow-sm">
                          AI Agent
                        </span> */}
                      </div>
                    </div>
                  </div>

                  {/* Mobile menu button - moved to right side */}
                  <button
                    className="md:hidden flex flex-col gap-1.5"
                    onClick={() => setMobileActionsOpen(!mobileActionsOpen)}
                    aria-label="Toggle menu"
                  >
                    <span
                      className={`block h-0.5 w-6 bg-gray-700 transition-transform duration-300 ease-in-out ${mobileActionsOpen ? 'rotate-45 translate-y-2' : ''
                        }`}
                    ></span>
                    <span
                      className={`block h-0.5 w-6 bg-gray-700 transition-opacity duration-300 ${mobileActionsOpen ? 'opacity-0' : ''
                        }`}
                    ></span>
                    <span
                      className={`block h-0.5 w-6 bg-gray-700 transition-transform duration-300 ease-in-out ${mobileActionsOpen ? '-rotate-45 -translate-y-2' : ''
                        }`}
                    ></span>
                  </button>
                </div>

                {/* Desktop actions (unchanged layout) */}
                <div className="hidden sm:flex items-center space-x-4">
                  <Tooltip>
                    {/* <Button
                      onClick={() => navigate("/mcp")}
                    >Configure MCP</Button> */}
                    <TooltipTrigger asChild>
                      <Button
                        className="bg-gradient-to-r from-blue-600 via-indigo-600 to-violet-600 hover:from-blue-700 hover:to-violet-700 text-white font-semibold rounded-xl px-5 shadow-md shadow-indigo-500/20 active:scale-[0.98] transition-all"
                        onClick={() => {
                          if (deployments.length >= 1) {
                            toast({
                              title: LanguageString("2012"),
                              description: LanguageString("1985"),
                              variant: 'destructive',
                            });
                            return;
                          }
                          setShowDeployDialog(true);
                        }}
                        disabled={deployments.length >= 1}
                      >
                        <Plus className="h-4 w-4 mr-1.5" />
                        <span>{LanguageString("2013")}</span>
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent>Deploy a new agent</TooltipContent>
                  </Tooltip>
                  {/* <Tooltip>
                    <TooltipTrigger asChild>
                      <Button
                        onClick={() => {
                          if (deployments.length >= 1) {
                            toast({
                              title: LanguageString("2012"),
                              description: LanguageString("1985"),
                              variant: 'destructive',
                            });
                            return;
                          }
                          setShowEmailDialog(true);
                        }}
                        disabled={deployments.length >= 1}
                      >
                        <Plus className="h-4 w-4" />
                        <span>{LanguageString("2014")}</span>
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent>{LanguageString("2015")}</TooltipContent>
                  </Tooltip> */}
                  {!isUserEmployee && (
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <Button variant="outline" onClick={() => setShowUpgrade(true)} >
                          <CreditCard className="h-4 w-4 mr-2" />
                          {LanguageString("1673")}
                        </Button>
                      </TooltipTrigger>
                      <TooltipContent>{LanguageString("1673")}</TooltipContent>
                    </Tooltip>
                  )}
                  {/* <Tooltip>
                    <TooltipTrigger asChild>
                      <Button variant="outline" onClick={() => setShowDocs(true)}>
                        <BookOpen className="h-4 w-4 mr-2" />
                        Documents
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent>Open deployment guide</TooltipContent>
                  </Tooltip> */}
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Button variant="outline" onClick={() => setShowHelpDesk(true)}>
                        <HeadsetIcon className="h-4 w-4 mr-2" />{LanguageString("2016")}
                      </Button>
                    </TooltipTrigger>

                  </Tooltip>
                  {/* <Tooltip>
                    <TooltipTrigger asChild>
                      <Button variant="ghost" onClick={handleLogout}>
                        <LogOut className="h-4 w-4 mr-2" />
                        Logout
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent>Log out and clear local data</TooltipContent>
                  </Tooltip> */}
                  <div className="ml-auto">
                    {/* Compact by default; expands on hover/open */}
                    <UserMenu />
                  </div>
                </div>
                <div
                  className={`md:hidden fixed top-[55px] left-0 w-full bg-white text-gray-900 shadow-lg transition-all duration-300 ease-in-out overflow-hidden ${mobileActionsOpen ? 'max-h-screen py-4 border-t' : 'max-h-0'
                    } z-[90]`}
                >
                  <div className="flex flex-col space-y-4 px-6 py-2">
                    {/* <button
                      onClick={() => {
                        navigate("/mcpOrchestrator");
                        setMobileActionsOpen(false);
                      }}
                      className="font-medium text-sm py-2 transition-colors hover:text-blue-600"
                    >
                      Configure MCP
                    </button> */}

                    <button
                      onClick={() => {
                        if (deployments.length >= 1) {
                          toast({
                            title: LanguageString("2012"),
                            description:
                              LanguageString("1985"),
                            variant: "destructive",
                          });
                          return;
                        }
                        setShowDeployDialog(true);
                        setMobileActionsOpen(false);
                      }}
                      className="font-medium text-sm py-2 transition-colors hover:text-blue-600"
                    >
                      {LanguageString("1743")}
                    </button>
                    {!isUserEmployee && (
                      <button
                        onClick={() => {
                          setShowUpgrade(true);
                          setMobileActionsOpen(false);
                        }}
                        className="font-medium text-sm py-2 transition-colors hover:text-blue-600"
                      >
                        {LanguageString("1673")}
                      </button>
                    )}

                    {/* <button
                      onClick={() => {
                        setShowDocs(true);
                        setMobileActionsOpen(false);
                      }}
                      className="font-medium text-sm py-2 transition-colors hover:text-blue-600"
                    >
                      Docs
                    </button> */}
                    <button

                      onClick={() => {
                        setShowHelpDesk(true)
                        setMobileActionsOpen(false);
                      }}
                      className="font-medium text-sm py-2 transition-colors hover:text-blue-600"
                    >
                      {LanguageString("2016")}
                    </button>

                    <button
                      onClick={() => {
                        handleLogout();
                        setMobileActionsOpen(false);
                      }}
                      className="font-medium text-sm py-2 text-red-600 hover:text-red-700"
                    >
                      {LanguageString("LogOut")}
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </header>

          <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8">
            {/* Stats Overview */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div className="relative group overflow-hidden bg-white/80 dark:bg-slate-900/60 backdrop-blur-xl border border-slate-200/80 dark:border-slate-800 rounded-3xl p-6 shadow-sm hover:shadow-md transition-all duration-300">
                <div className="flex items-center justify-between">
                  <div className="space-y-1">
                    <span className="text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">
                      {LanguageString("2017") || "Active Agents"}
                    </span>
                    <div className="text-3xl font-extrabold text-slate-900 dark:text-slate-100">
                      {deployments.filter(d => d.status === 'running').length}
                    </div>
                  </div>
                  <div className="p-3.5 bg-gradient-to-tr from-emerald-500 to-teal-500 text-white rounded-2xl shadow-md shadow-emerald-500/20 group-hover:scale-110 transition-transform duration-300">
                    <Activity className="h-6 w-6" />
                  </div>
                </div>
                {/* <div className="mt-4 pt-3 border-t border-slate-100 dark:border-slate-800/80 flex items-center text-xs text-emerald-600 dark:text-emerald-400 font-medium">
                  <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse mr-2" />
                  Realtime Monitoring Active
                </div> */}
              </div>

              <div className="relative group overflow-hidden bg-white/80 dark:bg-slate-900/60 backdrop-blur-xl border border-slate-200/80 dark:border-slate-800 rounded-3xl p-6 shadow-sm hover:shadow-md transition-all duration-300">
                <div className="flex items-center justify-between">
                  <div className="space-y-1">
                    <span className="text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">
                      {LanguageString("2018") || "Total Deployments"}
                    </span>
                    <div className="text-3xl font-extrabold text-slate-900 dark:text-slate-100">
                      {deployments.length}
                    </div>
                  </div>
                  <div className="p-3.5 bg-gradient-to-tr from-blue-600 via-indigo-600 to-violet-600 text-white rounded-2xl shadow-md shadow-indigo-500/20 group-hover:scale-110 transition-transform duration-300">
                    <Mail className="h-6 w-6" />
                  </div>
                </div>
                {/* <div className="mt-4 pt-3 border-t border-slate-100 dark:border-slate-800/80 flex items-center text-xs text-indigo-600 dark:text-indigo-400 font-medium">
                  <span className="w-2 h-2 rounded-full bg-indigo-500 mr-2" />
                  Cluster Service Provisioned
                </div> */}
              </div>
            </div>

            {/* Deployments */}
            <div className="space-y-6">
              <div className="flex justify-between items-center">
                <div className="flex items-center space-x-3">
                  <h2 className="text-xl font-bold tracking-tight text-slate-900 dark:text-slate-100">
                    {LanguageString("2019") || "Agent Deployments"}
                  </h2>
                  <span className="px-2.5 py-0.5 text-xs font-semibold bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 rounded-full border border-slate-200 dark:border-slate-700">
                    {deployments.length} Configured
                  </span>
                </div>
              </div>

              {deployments.length === 0 ? (
                <div className="relative overflow-hidden bg-white dark:bg-slate-900 rounded-3xl border border-slate-200/80 dark:border-slate-800 p-8 sm:p-12 text-center shadow-xl shadow-slate-200/50 dark:shadow-none transition-all">
                  <div className="absolute -top-24 -right-24 w-64 h-64 bg-indigo-500/10 rounded-full blur-3xl pointer-events-none" />
                  <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl pointer-events-none" />

                  <div className="relative z-10 max-w-lg mx-auto space-y-5">
                    <div className="inline-flex p-4 bg-gradient-to-tr from-blue-50 to-indigo-100 dark:from-slate-800 dark:to-indigo-950/60 rounded-3xl text-indigo-600 dark:text-indigo-400 border border-indigo-200/50 dark:border-indigo-800/50 shadow-inner">
                      <Mail className="h-10 w-10" />
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-slate-900 dark:text-slate-100 tracking-tight">
                        {LanguageString("2020") || "No Email Tracker Agent Deployed"}
                      </h3>
                      <p className="text-sm text-slate-500 dark:text-slate-400 mt-2 leading-relaxed">
                        {LanguageString("2021") || "Deploy an Email Tracker agent to watch Google Groups, automatically log status updates to Google Sheets, and deliver automated follow-up emails."}
                      </p>
                    </div>

                    <div className="pt-2">
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <Button
                            onClick={() => setShowDeployDialog(true)}
                            className="bg-gradient-to-r from-blue-600 via-indigo-600 to-violet-600 hover:from-blue-700 hover:to-violet-700 text-white font-semibold rounded-2xl px-7 py-3 shadow-lg shadow-indigo-500/25 active:scale-[0.98] transition-all"
                          >
                            <Plus className="h-4 w-4 mr-2" />
                            {LanguageString("2022") || "Deploy Agent Now"}
                          </Button>
                        </TooltipTrigger>
                        <TooltipContent>{LanguageString("2023")}</TooltipContent>
                      </Tooltip>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="grid gap-6">
                  {isAgentDeploying ? (
                    <Card>
                      <CardContent className="flex flex-col items-center justify-center py-12">
                        <Mail className="h-12 w-12 text-gray-400 mb-4" />
                        <h3 className="text-lg font-medium text-gray-900 mb-2">{LanguageString("2208")}</h3>
                        <p className="text-gray-500 mb-6 text-center max-w-md">
                          {/* {LanguageString("2021")} */}
                          {LanguageString("2207")}
                        </p>
                        <Tooltip>
                          <TooltipTrigger asChild>
                            <Button onClick={() => setShowDeployDialog(true)} disabled>
                              {/* <Plus className="h-4 w-4 mr-2" /> */}
                              {/* {LanguageString("2022")} */}
                              {LanguageString("2066")}
                            </Button>
                          </TooltipTrigger>
                          <TooltipContent>{LanguageString("2066")}</TooltipContent>
                        </Tooltip>
                      </CardContent>
                    </Card>
                  ) : (
                    deployments.map((deployment) => (
                      <Card key={deployment.id} className="group relative overflow-hidden border border-slate-200/80 dark:border-slate-800 bg-white/90 dark:bg-slate-900/90 backdrop-blur-2xl shadow-xl shadow-slate-200/40 dark:shadow-none rounded-3xl hover:border-indigo-400/50 dark:hover:border-indigo-600/50 transition-all duration-300">
                        {/* Top Gradient Accent Sheen */}
                        <div className="h-1.5 w-full bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600" />

                        {!isDeploymentAunthenticated.includes(deployment.id) ? (
                          <>
                            <CardHeader className="p-6 sm:p-7 pb-4">
                              <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
                                <div className="flex items-center space-x-3.5">
                                  <div className="p-3 bg-gradient-to-tr from-blue-600 via-indigo-600 to-purple-600 text-white rounded-2xl shadow-md shadow-indigo-500/20 group-hover:scale-105 transition-transform duration-300">
                                    <Bot className="h-6 w-6" />
                                  </div>
                                  <div>
                                    <CardTitle className="flex items-center space-x-3 text-lg font-bold tracking-tight text-slate-900 dark:text-slate-100">
                                      <span>{'Cosmitude Email Tracker Agent'}</span>
                                      {getStatusBadge(deployment.status)}
                                    </CardTitle>
                                    <CardDescription className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
                                      {LanguageString("2024")} {new Date(deployment.createdAt).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })}
                                    </CardDescription>
                                  </div>
                                </div>

                                {/* Control Bar */}
                                <div className="flex flex-wrap items-center gap-2 p-1.5 bg-slate-100/70 dark:bg-slate-800/70 backdrop-blur-md rounded-2xl border border-slate-200/60 dark:border-slate-700/60">
                                  {deployment.status === 'stopped' ? (
                                    <Tooltip>
                                      <TooltipTrigger asChild>
                                        <Button
                                          size="sm"
                                          className="rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white shadow-sm"
                                          onClick={() => handleControl('start', deployment)}
                                        >
                                          <Play className="h-4 w-4 mr-1" />
                                          <span className="text-xs font-semibold">Start</span>
                                        </Button>
                                      </TooltipTrigger>
                                      <TooltipContent>{LanguageString("2025")}</TooltipContent>
                                    </Tooltip>
                                  ) : (
                                    <Tooltip>
                                      <TooltipTrigger asChild>
                                        <Button
                                          size="sm"
                                          variant="outline"
                                          className="rounded-xl border-slate-200 dark:border-slate-700 hover:bg-slate-200/60 dark:hover:bg-slate-700"
                                          onClick={() => handleControl('stop', deployment)}
                                        >
                                          <Square className="h-4 w-4 mr-1 text-slate-600 dark:text-slate-300" />
                                          <span className="text-xs font-semibold">Pause</span>
                                        </Button>
                                      </TooltipTrigger>
                                      <TooltipContent>{LanguageString("2026")}</TooltipContent>
                                    </Tooltip>
                                  )}

                                  {showGroupFor && (
                                    <div className="fixed inset-0 z-[70] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4">
                                      <div className="w-full max-w-md bg-white dark:bg-slate-900 rounded-3xl shadow-2xl overflow-hidden border border-slate-200 dark:border-slate-800">
                                        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100 dark:border-slate-800">
                                          <h3 className="text-base font-bold text-slate-900 dark:text-slate-100">Update Google Group</h3>
                                          <Tooltip>
                                            <TooltipTrigger asChild>
                                              <Button variant="ghost" size="sm" onClick={() => setShowGroupFor(null)} className="rounded-xl">{LanguageString("1463")}</Button>
                                            </TooltipTrigger>
                                            <TooltipContent>{LanguageString("2027")}</TooltipContent>
                                          </Tooltip>
                                        </div>
                                        <div className="p-6 space-y-3">
                                          <label className="block text-xs font-semibold text-slate-700 dark:text-slate-300 uppercase tracking-wider">Google Group Email</label>
                                          <input
                                            className="w-full border border-slate-200 dark:border-slate-700 dark:bg-slate-800 rounded-xl px-4 py-2.5 text-sm focus:ring-2 focus:ring-indigo-500 outline-none"
                                            placeholder="team@googlegroups.com"
                                            value={groupEmailInput}
                                            onChange={(e) => setGroupEmailInput(e.target.value)} />
                                          <p className="text-xs text-slate-500">The agent watches this group for reply threads.</p>
                                        </div>
                                        <div className="flex items-center justify-end gap-2 px-6 py-4 bg-slate-50 dark:bg-slate-800/50 border-t border-slate-100 dark:border-slate-800">
                                          <Tooltip>
                                            <TooltipTrigger asChild>
                                              <Button variant="outline" onClick={() => setShowGroupFor(null)} className="rounded-xl">Cancel</Button>
                                            </TooltipTrigger>
                                            <TooltipContent>Cancel without saving</TooltipContent>
                                          </Tooltip>
                                          <Tooltip>
                                            <TooltipTrigger asChild>
                                              <Button
                                                className="rounded-xl bg-gradient-to-r from-blue-600 to-indigo-600 text-white"
                                                onClick={() => {
                                                  const dep = deployments.find(d => d.id === showGroupFor);
                                                  if (dep) handleUpdateGroup(dep);
                                                }}
                                                disabled={savingGroup}
                                              >
                                                {savingGroup ? 'Saving…' : 'Save'}
                                              </Button>
                                            </TooltipTrigger>
                                            <TooltipContent>Save group email</TooltipContent>
                                          </Tooltip>
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                  <Tooltip>
                                    <TooltipTrigger asChild>
                                      <Button
                                        size="sm"
                                        variant="outline"
                                        className="rounded-xl border-slate-200 dark:border-slate-700 text-xs font-semibold"
                                        onClick={() => handleEmailLimitClick(deployment)}
                                      >
                                        {LanguageString("2212") || "Daily Limit"}
                                      </Button>
                                    </TooltipTrigger>
                                    <TooltipContent>{LanguageString("2031")}</TooltipContent>
                                  </Tooltip>

                                  {/* <Tooltip>
                                    <TooltipTrigger asChild>
                                      <Button
                                        size="sm"
                                        variant="outline"
                                        className="rounded-xl border-slate-200 dark:border-slate-700 text-xs font-semibold"
                                        onClick={() => setShowRemindFor(deployment.id)}
                                      >
                                        <Bell className="h-3.5 w-3.5 mr-1 text-amber-500" />
                                        {LanguageString("2029") || "Remind"}
                                      </Button>
                                    </TooltipTrigger>
                                    <TooltipContent>{LanguageString("2031")}</TooltipContent>
                                  </Tooltip> */}

                                  <Tooltip>
                                    <TooltipTrigger asChild>
                                      <Button
                                        size="sm"
                                        variant="outline"
                                        className="rounded-xl border-slate-200 dark:border-slate-700 text-xs font-semibold"
                                        onClick={() => handleClickOnBlock(deployment)}
                                      >
                                        {LanguageString("2206") || "Blocked Domains"}
                                      </Button>
                                    </TooltipTrigger>
                                    <TooltipContent>{LanguageString('2197')}</TooltipContent>
                                  </Tooltip>

                                  <Tooltip>
                                    <TooltipTrigger asChild>
                                      <Button
                                        size="sm"
                                        className="rounded-xl bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 text-white font-semibold text-xs shadow-sm hover:shadow"
                                        onClick={() => handleInitiateAuth(deployment)}
                                        disabled={deployment.authStatus === 'authenticated' ||
                                          deployment.authStatus === 'authenticating' ||
                                          deployment.authStatus === 'warming_up' ||
                                          deployment.status !== 'running'}
                                      >
                                        {(deployment.authStatus === 'authenticating' || deployment.authStatus === 'warming_up') ? (
                                          <Loader2 className="h-3.5 w-3.5 mr-1.5 animate-spin" />
                                        ) : null}
                                        {LanguageString("2030") || "Authenticate"}
                                      </Button>
                                    </TooltipTrigger>
                                    <TooltipContent>{LanguageString("2031")}</TooltipContent>
                                  </Tooltip>

                                  <Tooltip>
                                    <TooltipTrigger asChild>
                                      <Button
                                        size="sm"
                                        variant="outline"
                                        className="rounded-xl border-slate-200 dark:border-slate-700 text-xs text-slate-600 dark:text-slate-300"
                                        onClick={() => handleRevokeAuth(deployment)}
                                      >
                                        {LanguageString("2032") || "Revoke"}
                                      </Button>
                                    </TooltipTrigger>
                                    <TooltipContent>{LanguageString("2033")}</TooltipContent>
                                  </Tooltip>

                                  <Tooltip>
                                    <TooltipTrigger asChild>
                                      <Button
                                        size="sm"
                                        variant="outline"
                                        className="rounded-xl border-rose-200 dark:border-rose-900/50 text-rose-600 hover:text-rose-700 hover:bg-rose-50 dark:hover:bg-rose-950/50"
                                        onClick={() => handleControl('delete', deployment)}
                                      >
                                        <Trash2 className="h-4 w-4" />
                                      </Button>
                                    </TooltipTrigger>
                                    <TooltipContent>{LanguageString("2034")}</TooltipContent>
                                  </Tooltip>
                                </div>
                              </div>
                            </CardHeader>

                            <CardContent className="p-6 sm:p-7 pt-2 space-y-4">
                              <div className="p-4 rounded-2xl bg-slate-50/80 dark:bg-slate-800/40 border border-slate-200/60 dark:border-slate-800 grid grid-cols-1 md:grid-cols-2 gap-4 items-center">
                                <div className="flex items-center space-x-3">
                                  <div className="p-2 bg-emerald-50 dark:bg-emerald-950/60 text-emerald-600 dark:text-emerald-400 rounded-xl">
                                    <FileSpreadsheet className="h-4 w-4" />
                                  </div>
                                  <div className="overflow-hidden">
                                    <span className="text-[11px] font-semibold uppercase tracking-wider text-slate-400 block">
                                      Google Sheets Roster
                                    </span>
                                    <span className="text-xs font-medium text-slate-700 dark:text-slate-300 truncate block">
                                      {LanguageString("2035") || "Automated Spreadsheet Sync Connected"}
                                    </span>
                                  </div>
                                </div>

                                <div className="flex items-center justify-start md:justify-end space-x-3">
                                  <span className="text-xs font-medium text-slate-500 dark:text-slate-400">OAuth Connection:</span>
                                  {deployment.authStatus === 'authenticated' && (
                                    <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border border-emerald-500/20 shadow-sm">
                                      <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-ping" />
                                      {LanguageString("2036") || "Authenticated"}
                                    </span>
                                  )}
                                  {deployment.authStatus === 'needs_auth' && (
                                    <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-amber-500/10 text-amber-600 dark:text-amber-400 border border-amber-500/20">
                                      <span className="w-1.5 h-1.5 rounded-full bg-amber-500" />
                                      {LanguageString("2037") || "Action Required: Click Auth"}
                                    </span>
                                  )}
                                  {deployment.authStatus === 'warming_up' && (
                                    <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-blue-500/10 text-blue-600 dark:text-blue-400 border border-blue-500/20 animate-pulse">
                                      {LanguageString("2038") || "Warming Up Pod"}
                                    </span>
                                  )}
                                  {deployment.authStatus === 'authenticating' && (
                                    <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-purple-500/10 text-purple-600 dark:text-purple-400 border border-purple-500/20 animate-pulse">
                                      {LanguageString("2039") || "Connecting OAuth..."}
                                    </span>
                                  )}
                                  {deployment.authStatus === 'error' && (
                                    <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-rose-500/10 text-rose-600 dark:text-rose-400 border border-rose-500/20">
                                      {LanguageString("2040") || "Auth Error"}
                                    </span>
                                  )}
                                  {!deployment.authStatus && (
                                    <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-slate-100 text-slate-600 border border-slate-200">
                                      {LanguageString("2011") || "Pending Provision"}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </CardContent>
                          </>
                        ) : (
                          <>
                            <CardContent className="relative flex flex-col items-center justify-center py-10 space-y-4">
                              <button
                                onClick={(e) => {
                                  e.stopPropagation(); // This prevents the event from reaching parents
                                  handleControl('delete', deployment)
                                }}
                                className="absolute top-3 right-3 p-1 rounded-md text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-colors"
                              >
                                <X size={24} />
                              </button>
                              <p className="text-gray-600 text-center">
                                {LanguageString("2209")}
                              </p>

                              <Button
                                onClick={() => handleInitiateAuth(deployment)}
                                disabled={deployment.status !== "running"}
                              >
                                {LanguageString("2126")}
                              </Button>
                            </CardContent>
                          </>
                        )}
                      </Card>
                    ))
                  )}
                </div>
              )}
            </div>
          </main>

          {showDocs && (
            <div className="fixed inset-0 z-[80] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4">
              <div className="w-full max-w-3xl max-h-[85vh] bg-white rounded-lg shadow-lg overflow-hidden flex flex-col">
                <div className="flex items-center justify-between px-4 py-3 border-b">
                  <div className="flex items-center gap-2">
                    <BookOpen className="h-5 w-5 text-blue-600" />
                    <h3 className="text-lg font-semibold">{LanguageString("Document")}</h3>
                  </div>
                  <div className="flex gap-2">
                    <Button variant="ghost" size="sm" onClick={() => setShowDocs(false)}>{LanguageString("1463")}</Button>
                  </div>
                </div>
                <div className="p-5 overflow-y-auto">
                  <h2 className="text-xl font-bold mb-2">Deployment Guide for Cosmitude Email‑Tracker Agent</h2>
                  <p className="text-sm text-gray-600 mb-4">
                    This document outlines the complete workflow for deploying, authenticating, and managing your Cosmitude Email‑Tracker Agent.
                  </p>
                  <h3 className="text-lg font-semibold mt-4 mb-2">Important: App Verification &amp; Privacy</h3>
                  <div className="rounded-md border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900">
                    <p className="mb-2">
                      <strong>App under verification:</strong> You may see a Google warning that this app could be unsafe. This is expected while verification is in progress.
                    </p>
                    <ul className="list-disc pl-5 space-y-1">
                      <li>
                        <strong>No data collection:</strong> We do <em>not</em> collect or store your emails, Google Sheets data, or message content on Cosmitude servers.
                      </li>
                      <li>
                        <strong>Sandboxed microservice:</strong> Each agent deployment runs in an isolated, sandboxed Kubernetes microservice managed by CloudRunner.
                      </li>
                      <li>
                        <strong>Persistent &amp; Secure Tokens:</strong> OAuth tokens are saved securely in persistent volume storage (<code>/deps/data/token_calendar.pickle</code>) and are used strictly to operate your agent instance.
                      </li>
                    </ul>
                  </div>

                  <h3 className="text-lg font-semibold mt-4 mb-2">1. Access Email Tracker</h3>
                  <p className="mb-2">Open your browser and navigate to the Cosmitude Email Tracker:</p>
                  <p className="mb-2">
                    <a href="https://et.cosmitude.com" target="_blank" rel="noreferrer" className="text-blue-600 underline">
                      https://et.cosmitude.com
                    </a>
                  </p>
                  <p className="mb-4">Sign in using your authorized Google Account.</p>

                  <h3 className="text-lg font-semibold mt-4 mb-2">2. Deploy a New Agent</h3>
                  <p className="mb-2">
                    Click <strong>Deploy Agent</strong> from the dashboard header. In the setup dialog, enter the following parameters:
                  </p>
                  <ul className="list-disc pl-6 mb-2">
                    <li><strong>Google Sheets URL</strong> – The full URL of your target spreadsheet. Ensure the sheet exists and your account has editor permissions.</li>
                    <li><strong>Subject Line Template</strong> – The email subject line for your outreach campaign.</li>
                    <li><strong>Body Template</strong> – The main body text for your emails.</li>
                  </ul>
                  <p className="mb-4">
                    Click <strong>Deploy</strong>. CloudRunner will automatically provision a dedicated container, persistent storage (PVC), and a secure reverse proxy endpoint.
                  </p>

                  <h3 className="text-lg font-semibold mt-4 mb-2">3. Automatic Readiness &amp; Authentication</h3>
                  <p className="mb-2">
                    The dashboard continuously polls your agent's proxy endpoint. As soon as the container finishes booting:
                  </p>
                  <ol className="list-decimal pl-6 mb-2 space-y-1">
                    <li>The agent status automatically updates to <code>running</code> and enables the <strong>Authenticate</strong> button—no page refresh required.</li>
                    <li>Click <strong>Authenticate</strong>. A new tab opens with the Google consent screen. Select your Google account and grant Gmail and Sheets permissions.</li>
                    <li>Once approved, the system automatically saves the authorization tokens and updates the badge to <strong>Authenticated</strong>.</li>
                  </ol>

                  <h3 className="text-lg font-semibold mt-4 mb-2">4. Automated Roster Sync &amp; Reply Tracking</h3>
                  <ul className="list-disc pl-6 mb-2 space-y-1">
                    <li><strong>Automatic Roster Sync:</strong> The agent reads your <strong>`Main`</strong> roster tab in Google Sheets. Any newly added email IDs are automatically imported into the active run sheet (`EmailTracker_Run_001`) and added to the <strong>`Pending`</strong> tab.</li>
                    <li><strong>Reply Polling &amp; AI Classification:</strong> The agent scans Gmail for incoming replies on tracked threads. Replies containing status indicators (such as <em>done</em>, <em>completed</em>, <em>resolved</em>, or <em>fixed</em>) are automatically classified, updating the roster and moving completed contacts to the <strong>`Completed`</strong> tab.</li>
                    <li><strong>Delivery &amp; Bounce Logging:</strong> Delivery successes are logged to `Success_Mail`, while bounces are automatically captured in `Failed_Mail`.</li>
                  </ul>

                  <h3 className="text-lg font-semibold mt-4 mb-2">5. Agent Controls &amp; Advanced Management</h3>
                  <ul className="list-disc pl-6 mb-2 space-y-1">
                    <li><strong>Daily Email Limit:</strong> Adjust the maximum daily email sending limit using the interactive slider.</li>
                    <li><strong>Blocked Domains:</strong> Add specific email domains (e.g. consumer or unverified domains) to prevent automated emails from being sent to those domains.</li>
                    <li><strong>Send Reminders:</strong> Trigger instant follow-up reminder emails to all pending contacts with custom subject lines and bodies.</li>
                    {/* <li><strong>Live Pod Logs:</strong> View live execution and debugging logs directly from the agent container.</li> */}
                    <li><strong>Revoke &amp; Reset:</strong> Safely clear OAuth tokens if you need to re-authenticate with a different Google account.</li>
                    <li><strong>Start / Stop / Delete:</strong> Control container lifecycle without losing saved configurations.</li>
                  </ul>

                  <p className="text-xs text-gray-500 mt-4">
                    Updated for Cosmitude Email Tracker System.
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* Dialogs */}
          {showDeployDialog && (
            <DeploymentDialog
              onClose={() => setShowDeployDialog(false)}
              onDeploy={handleDeploy}
            />
          )}

          {/* Dialogs */}
          {showEmailDialog && (
            <EmailSender
              onClose={() => setShowEmailDialog(false)}
              onDeploy={handleEmailSender}
            />
          )}

          {showLogsFor && (
            <LogsViewer
              deploymentId={showLogsFor}
              onClose={() => setShowLogsFor(null)}
            />
          )}

          {showSettingsFor && (
            <SettingsDialog
              deployment={deployments.find(d => d.id === showSettingsFor)!}
              onClose={() => setShowSettingsFor(null)}
              onUpdate={async (updatedDeployment) => {
                // Update local state first; preserve name, only update sheetsUrl (and other non-name fields)
                setDeployments(prev => prev.map(d =>
                  d.id === updatedDeployment.id
                    ? { ...d, sheetsUrl: updatedDeployment.sheetsUrl }
                    : d
                ));

                // Push new Sheets URL to the running agent via agent proxy, not direct IP
                try {
                  if (updatedDeployment.sheetsUrl) {
                    const base = agentBase(updatedDeployment.id);
                    const res = await fetch(`${base}/config/sheet`, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      credentials: 'include',
                      body: JSON.stringify({ url: updatedDeployment.sheetsUrl })
                    });
                    const data = await res.json().catch(() => ({} as any));
                    if (res.ok) {
                      toast({
                        title: LanguageString("2041"),
                        description: data?.verified ? LanguageString("2042") : LanguageString("2043")
                      });
                    } else {
                      throw new Error(JSON.stringify(data));
                    }
                  } else {
                    toast({ title: 'Saved locally', description: 'Sheets URL was empty.' });
                  }
                } catch (e: any) {
                  toast({ title: LanguageString("2044"), description: e?.message || String(e), variant: 'destructive' });
                } finally {
                  setShowSettingsFor(null);
                }
              }}
            />
          )}

          {showRemindFor && (
            <div className="fixed inset-0 z-[70] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4">
              <div className="w-full max-w-xl bg-white rounded-lg shadow-lg overflow-hidden">
                <div className="flex items-center justify-between px-4 py-3 border-b">
                  <h3 className="text-lg font-semibold">{LanguageString("2045")}</h3>
                  <Button variant="ghost" size="sm" onClick={() => setShowRemindFor(null)}>{LanguageString("1463")}</Button>
                </div>
                <div className="p-4 space-y-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">{LanguageString("2046")}</label>
                    <input
                      className="w-full border rounded px-3 py-2 text-sm"
                      value={reminderSubject}
                      onChange={(e) => setReminderSubject(e.target.value)}
                      placeholder={LanguageString("2046")}
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">{LanguageString("2046")}</label>
                    <textarea
                      className="w-full border rounded px-3 py-2 text-sm h-48"
                      value={reminderBody}
                      onChange={(e) => setReminderBody(e.target.value)}
                      placeholder={LanguageString("2048")}
                    />
                  </div>
                </div>
                <div className="flex items-center justify-end gap-2 px-4 py-3 border-t">
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Button variant="outline" onClick={() => setShowRemindFor(null)}>{LanguageString("Cancel")}</Button>
                    </TooltipTrigger>
                    <TooltipContent>{LanguageString("2049")}</TooltipContent>
                  </Tooltip>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Button
                        onClick={() => {
                          const dep = deployments.find(d => d.id === showRemindFor);
                          if (dep) handleSendReminders(dep);
                        }}
                        disabled={sendingReminders}
                      >
                        {sendingReminders ? 'Sending…' : 'Send reminders now'}
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent>{LanguageString("2050")}</TooltipContent>
                  </Tooltip>
                </div>
              </div>
            </div>
          )}
          {showDailyEmailLimit && (
            <div className="fixed inset-0 z-[70] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4">
              <div className="w-full max-w-xl bg-white rounded-lg shadow-lg overflow-hidden">
                <div className="flex items-center justify-between px-4 py-3 border-b">
                  <h3 className="text-lg font-semibold">{LanguageString("2211")}</h3>
                  <Button variant="ghost" size="sm" onClick={() => setShowDailyEmailLimit(!showDailyEmailLimit)}>{LanguageString("1463")}</Button>
                </div>
                <div className="p-4 space-y-3">
                  <div className="flex items-center justify-between">
                    <label className="text-sm font-medium text-gray-700">
                      {LanguageString("2211")}
                    </label>
                    <span className="text-sm font-semibold text-blue-600">
                      {dailyEmailLimit}
                    </span>
                  </div>
                  <input
                    type="range"
                    min={minEmailLimit}
                    max={maxEmailLimit}
                    step={1}
                    value={dailyEmailLimit}
                    onChange={(e) => setDailyEmailLimit(Number(e.target.value))}
                    className="w-full h-2 rounded-lg appearance-none cursor-pointer"
                    style={{
                      background: `linear-gradient(to right, #2563eb 0%, #2563eb ${(dailyEmailLimit / maxEmailLimit) * 100
                        }%, #e5e7eb ${(dailyEmailLimit / maxEmailLimit) * 100}%, #e5e7eb 100%)`
                    }}
                  />
                  <div className="flex justify-between text-xs text-gray-400">
                    <span>{minEmailLimit}</span>
                    <span>{maxEmailLimit}</span>
                  </div>
                </div>
                <div className="flex items-center justify-end gap-2 px-4 py-3 border-t">
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Button
                        onClick={() => {
                          const dep = deployments.find(d => d.id === selectedDeployment);
                          if (dep) updateEmailLimit(dep);
                        }}
                        disabled={updatingEmailDailyLimit}
                      >
                        {LanguageString("Update")}
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent>{LanguageString("2050")}</TooltipContent>
                  </Tooltip>
                </div>
              </div>
            </div>
          )}
          {showBlockedDomains && (
            <div className="fixed inset-0 z-[70] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4">
              <div className="w-full max-w-xl bg-white rounded-lg shadow-lg overflow-hidden">
                <div className="flex items-center justify-between px-4 py-3 border-b">
                  <h3 className="text-lg font-semibold">{LanguageString("2197")}</h3>
                  <Button variant="ghost" size="sm" onClick={() => setShowBlockedDomains(false)}>{LanguageString("1463")}</Button>
                </div>
                <div className="p-4 space-y-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">{LanguageString("2210")}</label>
                    <input
                      className="w-full border rounded px-3 py-2 text-sm"
                      value={blockedDomain}
                      onChange={(e) => setBlockedDomain(e.target.value.trim().toLowerCase())}
                      placeholder="eg., rediff.com"
                    />
                  </div>
                  <Button
                    size="sm"
                    variant="outline"
                    className="mt-2"
                    onClick={() => {
                      checkForValidDomain(blockedDomain)
                    }}
                  >
                    {LanguageString("2202")}
                  </Button>
                </div>
                <div className="p-4 space-y-3">
                  {blockedDomainList.length > 0 && (
                    <div className="mt-4">
                      <p className="text-sm font-medium text-gray-700 mb-2">
                        {LanguageString("2197")}
                      </p>

                      <div className="flex flex-wrap gap-2">
                        {blockedDomainList.map((domain, index) => (
                          <div
                            key={index}
                            className="flex items-center gap-2 bg-red-50 text-red-700 px-3 py-1 rounded-full text-sm"
                          >
                            <span>{domain}</span>
                            <button
                              onClick={() =>
                                setBlockedDomainList(blockedDomainList.filter((_, i) => i !== index))
                              }
                              className="hover:text-red-900"
                            >
                              ✕
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
                <div className="flex items-center justify-end gap-2 px-4 py-3 border-t">
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Button variant="outline" onClick={() => setShowBlockedDomains(false)}>{LanguageString("Cancel")}</Button>
                    </TooltipTrigger>
                    <TooltipContent>{LanguageString("1463")}</TooltipContent>
                  </Tooltip>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Button
                        onClick={() => {
                          const dep = deployments.find(d => d.id === blockedFor);
                          if (dep) updateBlockedEmails(dep);
                        }}
                        disabled={addingBlockedDomains}
                      >
                        {addingBlockedDomains ? LanguageString("2201") : LanguageString("2200")}
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent>{LanguageString("2050")}</TooltipContent>
                  </Tooltip>
                </div>
              </div>
            </div>
          )}
          {showHelpDesk && (
            <div className="fixed inset-0 z-[80] bg-black/50 backdrop-blur-sm flex items-end sm:items-center sm:justify-center p-2 sm:p-4">
              <div className="w-[50dvh] sm:max-w-3xl h-[90dvh] sm:h-auto sm:max-h-[85vh] bg-white rounded-t-2xl sm:rounded-lg shadow-lg overflow-hidden flex flex-col">
                {/* Header */}
                <div className="flex items-center justify-between px-4 py-3 border-b bg-white sticky top-0 z-10">
                  <div className="flex items-center gap-2">
                    <HeadsetIcon className="h-5 w-5 text-blue-600" />
                    <h3 className="text-lg font-semibold">{LanguageString("2016")}</h3>
                  </div>
                  <div className="flex gap-2">
                    <button
                      onClick={() => setShowHelpDesk(false)}
                      className="inline-flex items-center justify-center rounded-md px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-100"
                    >
                      {LanguageString("1463")}
                    </button>
                  </div>
                </div>

                <div className="flex-1 overflow-y-auto p-5 sm:p-6">
                  <div className="grid grid-cols-1  gap-3">
                    {/* WhatsApp Support */}
                    <div
                      onClick={handleDocumentClick}
                      className="
            group block w-full box-border
            rounded-2xl border border-neutral-200
            bg-white/80 backdrop-blur-sm p-4 shadow-sm
            transition-[colors,box-shadow,transform] duration-200
            hover:shadow-md hover:-translate-y-0.5
          "
                      aria-pressed={showDocs}
                    >
                      <div className="flex items-center gap-3">
                        <span className="inline-flex items-center justify-center rounded-xl border border-neutral-200 p-2 group-hover:bg-indigo-50 shrink-0">
                          <FileText className="h-5 w-5" />
                        </span>
                        <div className="min-w-0 flex-1 text-left">
                          <div className="font-semibold">{LanguageString("2051")}</div>
                          <div className="text-xs text-muted-foreground">
                            {LanguageString("2052")}
                          </div>
                        </div>
                      </div>
                    </div>
                    <a
                      href="https://wa.me/918050396072?text=Hi,%20I%20need%20support."
                      target="_blank"
                      rel="noopener noreferrer"
                      className="group flex items-center gap-3 rounded-xl border bg-white/80 backdrop-blur-sm p-4 shadow-sm hover:shadow-md transition-all hover:-translate-y-0.5 active:translate-y-0"
                    >
                      <span className="inline-flex items-center justify-center rounded-lg border p-2 group-hover:bg-emerald-50">
                        <MessageCircle className="h-5 w-5" />
                      </span>
                      <div className="flex-1">
                        <div className="font-medium">{LanguageString("2053")}</div>
                        <div className="text-xs text-muted-foreground">
                          {LanguageString("2054")}
                        </div>
                      </div>
                      <span className="text-xs font-semibold text-emerald-700 group-hover:underline">
                        {LanguageString("Chat")}
                      </span>
                    </a>

                    {/* Email Support */}
                    <div
                      onClick={handleEmailClick}
                      className="
    group block w-full box-border
    rounded-2xl border border-neutral-200
    bg-white/80 backdrop-blur-sm p-4 shadow-sm
    transition-[colors,box-shadow,transform] duration-200
    hover:shadow-md hover:-translate-y-0.5
  "
                    >
                      <div className="flex items-center gap-3">
                        <span className="inline-flex items-center justify-center rounded-xl border border-neutral-200 p-2 group-hover:bg-blue-50 shrink-0">
                          <Mail className="h-5 w-5" />
                        </span>
                        <div className="min-w-0 flex-1 text-left">
                          <div className="font-semibold">{LanguageString("2055")}</div>
                          <div className="text-xs text-muted-foreground">{LanguageString("2056")}</div>
                        </div>
                        <span className="text-xs font-semibold text-blue-700 group-hover:underline whitespace-nowrap shrink-0">
                          {LanguageString("2057")}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <footer className="fixed bottom-0 left-0 w-full ">
            <div className="max-w-6xl mx-auto text-center py-3">
              <a
                href="https://cosmitude.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                © Cosmitude Softwares Private Limited. All rights reserved.
              </a>
            </div>
          </footer>
          {showUpgrade && (
            <UpgradePage showUpgrade={showUpgrade} setShowUpgrade={setShowUpgrade} />
          )}
        </div>
      </TooltipProvider>
    </>
  );
};

export default DashboardComponent;